import React from 'react';

const OurServiceSection = ({ item }) => {
	return (
		<>
			<div className='box' data-aos='zoom-in'>
				<span>{item.id}</span>
				<i className={item.fontawesomeIcon}></i>
				<h3>{item.title}</h3>
				<p>{item.desc}</p>
			</div>
		</>
	);
};

export default OurServiceSection;
